import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#332D2B] bg-[#0F0C0B] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-3xl text-[#C8A96A]">football.zone</div>
          <p className="text-[#A8A39D] mt-3 text-sm max-w-xs">
            A vintage club for raffles and classic football jerseys. Curated by hand, played from the heart.
          </p>
        </div>
        <div>
          <div className="fz-label">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/raffles" className="text-[#F2EBDD] hover:text-[#C8A96A]">Live Raffles</Link></li>
            <li><Link to="/shop" className="text-[#F2EBDD] hover:text-[#C8A96A]">Jersey Shop</Link></li>
            <li><Link to="/#reviews" className="text-[#F2EBDD] hover:text-[#C8A96A]">Reviews</Link></li>
            <li><Link to="/contact" className="text-[#F2EBDD] hover:text-[#C8A96A]">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="fz-label">Club</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/admin/login" className="text-[#F2EBDD] hover:text-[#C8A96A]">Host Login</Link></li>
            <li><a href="mailto:itsfootballzonecouk@gmail.com" className="text-[#F2EBDD] hover:text-[#C8A96A]">itsfootballzonecouk@gmail.com</a></li>
            <li><a href="#" className="text-[#F2EBDD] hover:text-[#C8A96A]">Terms</a></li>
            <li><a href="#" className="text-[#F2EBDD] hover:text-[#C8A96A]">Privacy</a></li>
          </ul>
        </div>
        <div>
          <div className="fz-label">Match Programme</div>
          <p className="font-mono-retro text-xs tracking-[0.2em] text-[#756F6B] uppercase">
            Kick-off 19:45 — Floodlights on. UK bank transfer at checkout. Shipping worldwide.
          </p>
        </div>
      </div>
      <div className="border-t border-[#332D2B]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-mono-retro text-[11px] tracking-[0.3em] uppercase text-[#756F6B]">© 2026 football.zone — all rights reserved</div>
          <div className="font-mono-retro text-[11px] tracking-[0.3em] uppercase text-[#756F6B]">Made for the beautiful game</div>
        </div>
      </div>
    </footer>
  );
}
